import { getHotelItem, getHotelItems } from 'supportAssistant/utils/orderUtils'
import LesaPurchaseSummaryOrderItemStatus from './Common/LesaPurchaseSummaryOrderItemStatus'
import Group from 'components/utils/Group'
import moment from 'moment'
import { DAY_MONTH_NAME_SHORT, DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import { RESERVATION_STATE_PENDING } from 'constants/reservation'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import { ITEM_STATUS_AWAITING_DATES, ORDER_STATUS_COMPLETED } from 'constants/cart'
import styled from 'styled-components'
import { rem } from 'polished'

export const InlineContainer = styled(Group)`
  > * + *::before {
    content: '·';
    margin: 0 ${rem(4)};
    speak-as: bullets;
    speak: none;
  }
`

interface Props {
  order: App.Order
  isTour: boolean
}

export default function LesaHotelPurchaseItem({ isTour, order }: Props) {
  const intl = useIntl()
  const items = getHotelItems(order)
  const item = getHotelItem(order)

  let status = item.status

  if (isTour && item.reservation) {
    if (item.onHold) {
      status = ITEM_STATUS_AWAITING_DATES
    } else if (order.status === ORDER_STATUS_COMPLETED && item.reservation.state === RESERVATION_STATE_PENDING) {
      status = RESERVATION_STATE_PENDING
    } else if (item.reservation.travellerDetailsRequired) {
      status = 'needsDetails'
    }
  }

  const startDate = item.reservation?.startDate ? moment(item.reservation?.startDate).format(DAY_MONTH_NAME_SHORT) : undefined
  const endDate = item.reservation?.endDate ? moment(item.reservation?.endDate).format(DMY_CASUAL_SHORT_FORMAT) : undefined
  const dateString = startDate && endDate ? `${startDate} - ${endDate}` : undefined
  const showDates = !item.onHold && item.reservation && item.reservation.state !== RESERVATION_STATE_PENDING && dateString

  const duration = item.duration && item.durationLabel

  const rooms = items.length
  const roomString = rooms ? intl.formatMessage({
    id: '7NM5EUk28Yj-1WHjO-b5',
    defaultMessage: '{count, plural, one {# room} other {# rooms}}',
    description: 'Number of rooms for hotel purchase item on the hotel or room booking page',
  }, { count: rooms }) : undefined

  return (
    <InlineContainer direction="horizontal">
      {!startDate && <LesaPurchaseSummaryOrderItemStatus status={status} />}
      {showDates && <BodyText variant="small" colour="neutral-two">{dateString}</BodyText>}
      {duration && <BodyText variant="small" colour="neutral-two">{duration}</BodyText>}
      {roomString && <BodyText as="span" variant="small" colour="neutral-two">{roomString}</BodyText>}
    </InlineContainer>
  )
}
